import type { RemoteConfig } from 'src/interfaces/remoteConfig'
import type { State } from '../reducers/types'

/** By reference: filtering and sorting belong in the component under `useMemo`. */
export const getRemoteConfigs = (state: State): RemoteConfig[] => {
  return state.remoteConfig.remoteConfigs
}

export const getRemoteConfigsLoading = (state: State): boolean => {
  return state.remoteConfig.remoteConfigsLoading
}

export const getRemoteConfigSaving = (state: State): boolean => {
  return state.remoteConfig.saving
}

export const getRemoteConfigDeletingId = (state: State): string | null => {
  return state.remoteConfig.deletingId
}
